import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";

export const ORG_TYPES = ["State / Local Government", "Federal / Defense", "Private Enterprise", "Other"];
export const CONTACT_METHODS = ["Email", "Phone", "Video Conference", "In-Person"];
export const SERVICES = [
  "Business Internet & Cable TV",
  "Satellite Business Internet",
  "Cybersecurity & Risk Management",
  "Cloud Infrastructure & Managed Services",
  "Artificial Intelligence & Automation",
  "Advanced Networking & Connectivity",
  "Unified Communications / UCaaS",
  "Contact Center & CX Technology / CCaaS",
  "IoT & Mobility Solutions",
  "Vendor-Neutral Advisory / Architecture Design Only",
  "Other / Custom Requirement",
];
export const CLOUDS = ["AWS", "Azure", "Google Cloud", "Private / On-Prem", "Hybrid / Multi"];
export const COMPLIANCE = ["NIST 800-53", "CMMC", "HIPAA", "PCI-DSS", "State / Agency Specific"];
export const TIMELINES = ["Immediate (< 30 days)", "Near-term (1–3 months)", "Planning (3–6 months)", "Exploratory"];

export const INITIAL_FORM = {
  org_name: "", industry: "", org_type: "", hq_city_state: "", num_employees: "", website: "", it_budget: "",
  full_name: "", title_role: "", email: "", phone: "", preferred_contact: "",
  services: [], cloud_providers: [], security_stack: "", rmm_tools: "", network_summary: "",
  num_locations: "", num_endpoints: "", compliance: [], environment_na: false,
  business_drivers: "", desired_outcomes: "", target_start: "", decision_timeline: "", budget_range: "",
  additional_notes: "", printed_name: "", authorized: false,
};

export const inputCls = "bg-[#05071F] border-white/15 text-white placeholder:text-slate-600 focus-visible:ring-cyan-400";

export const Section = ({ num, title, children }) => (
  <div className="border border-white/10 bg-[#0B1035] p-6 sm:p-8">
    <p className="font-mono text-sm text-violet-400">Section {num}</p>
    <h3 className="mt-1 font-heading text-xl font-medium text-white">{title}</h3>
    <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-5">{children}</div>
  </div>
);

export const Field = ({ label, children, full }) => (
  <div className={full ? "sm:col-span-2" : ""}>
    <Label className="text-sm text-slate-300">{label}</Label>
    <div className="mt-1.5">{children}</div>
  </div>
);

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const CheckGroup = ({ options, values, onToggle, prefix, disabled = false }) => (
  <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 ${disabled ? "opacity-40 pointer-events-none" : ""}`}>
    {options.map((opt) => (
      <label key={opt} className="flex items-start gap-3 cursor-pointer">
        <Checkbox
          data-testid={`${prefix}-${slugify(opt)}`}
          disabled={disabled}
          checked={values.includes(opt)}
          onCheckedChange={() => onToggle(opt)}
          className="border-white/30 data-[state=checked]:bg-cyan-400 data-[state=checked]:text-[#05071F] mt-0.5"
        />
        <span className="text-sm text-slate-300">{opt}</span>
      </label>
    ))}
  </div>
);

export const RadioPills = ({ options, value, onChange, prefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((opt) => (
      <button key={opt} type="button" data-testid={`${prefix}-${slugify(opt)}`}
        onClick={() => onChange(opt)}
        className={`text-sm px-4 py-2 rounded-full border transition-colors ${
          value === opt ? "bg-cyan-400 text-[#05071F] border-cyan-400 font-semibold" : "border-white/20 text-slate-300 hover:border-white/50"
        }`}>
        {opt}
      </button>
    ))}
  </div>
);
